export const routes = {
  main: '/',
  signup: '/signup',
  signin: '/signin',
  dashboard: '/dashboard',
  confirmRegister: '/confirm_register',
  licence: '/licence',
  plan: '/plan',
  startSubscription: '/start_subscription',
  resetPassword: '/reset-password',
  profile: '/profile',
  upgradeOnlinePlan: '/start_subscription-online',
  upgradeEUOnlinePlan: '/start_subscription-eu-online',
  upgradeOfflinePlan: '/start_subscription-offline',
  enterprisePlan: '/enterprise-plan',
  subclinics: '/subclinics',
  forgotPassword: '/forgot-password',
  createPassword: '/reset_password',
  creditCardDetails: '/credit-card-details',
};
